import React from 'react'

const ArrowUp = () => {
    return (
        <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0)">
            <path d="M18.747 11.8173L10.1104 4.09008C9.94855 3.94516 9.72884 3.86377 9.4998 3.86377C9.27071 3.86377 9.05105 3.94521 8.88909 4.09013L0.252959 11.8174C-0.0843197 12.1192 -0.0843197 12.6084 0.252959 12.9102C0.59018 13.2119 1.13704 13.212 1.47431 12.9102L9.4998 5.72934L17.5257 12.9102C17.6943 13.0611 17.9154 13.1365 18.1364 13.1365C18.3574 13.1365 18.5785 13.0611 18.7471 12.9101C19.0843 12.6084 19.0843 12.1191 18.747 11.8173Z" fill="#DAD6D6"/>
        </g>
            <defs>
                <clipPath id="clip0">
                    <rect width="19" height="17" fill="white"/>
                </clipPath>
            </defs>
        </svg>

    )
}


export default ArrowUp